export default {
  title: 'Ganhe Pontos e Obtenha Recompensas',
  header: {
    pickup: 'Levantamento em 5 Minutos',
  },
  recommendations: {
    title: 'Recomendados',
  },
  discounts: {
    title: 'Descontos',
    data: [
      {
        title: '+125 Pontos Extra',
        description: 'Avalie-nos no Google',
      },
      {
        title: '+{{amount}} de Desconto',
        description: '+{{amount}} de Desconto ao pagar com o código {{code}}',
      },
    ],
    button: {
      add: '+ Adicionar',
    },
  },
  rewards: {
    title: 'Recompensas e Cupões',
    balance: 'Saldo',
    points: 'Pontos',
  },
};
